import axios from '../configs/axios';
import { serializeQuery } from '../utility/helpers/serializeQuery';

class UserRepository {
    async login(payload) {
        const response = await axios.post('auth/login', payload);
        return response;
    }

    async register(payload) {
        const response = await axios.post('auth/register', payload);
        return response;
    }

    async getProfile() {
        const response = await axios.get('auth/profile');
        return response;
    }

    async getUserById(userId) {
        const response = await axios.get(`user/${userId}`);
        return response;
    }

    async getUserByEmail(emailAddress) {
        const response = await axios.get(`user/by_email/${emailAddress}`);
        return response;
    }

    async getUsers(payload) {
        const response = await axios.get(`user?${serializeQuery(payload)}`);
        return response;
    }

    async searchLrsLawyers(searchData) {
        const response = await axios.post(
            'user/lrs/lawyers/filter',
            searchData,
        );
        return response;
    }

    async findNextAvailableLawyer(searchData) {
        const response = await axios.post(
            'user/findNextAvailableLawyer',
            searchData,
        );
        return response;
    }

    async createOrUpdateLrsUserWithReferral(referral_id = false, data) {
        let response;
        if (referral_id) {
            response = await axios.put(
                `user/referralWithClient/${referral_id}`,
                data,
            );
        } else {
            response = await axios.post('user/referralWithClient', data);
        }

        return response;
    }

    async createOrUpdateUser(userId = false, data) {
        let response;
        if (userId) {
            response = await axios.put(`user/update/${userId}`, data);
        } else {
            response = await axios.post('user/create', data);
        }

        return response;
    }

    async updateContactData(userId, payload) {
        const response = await axios.put(
            `user/updateContact/${userId}`,
            payload,
        );
        return response;
    }

    async updateInsurance(userId, payload) {
        const response = await axios.put(
            `user/updateInsurance/${userId}`,
            payload,
        );
        return response;
    }

    async checkEmailIsUnique(emailAddress) {
        const response = await axios.get(`auth/emailIsFree/${emailAddress}`);
        return response;
    }

    async checkLsbcNumberIsUnique(lsbcNumber) {
        const response = await axios.get(`auth/lsbcIsFree/${lsbcNumber}`);
        return response;
    }

    async createHoldReferral(payload) {
        const response = await axios.post('user/holdReferral', payload);
        return response;
    }

    async updateHoldReferral(id, payload) {
        const response = await axios.put(`user/holdReferral/${id}`, payload);
        return response;
    }

    async getHoldReferralsByUser(userId) {
        const response = await axios.get(`user/holdReferral/${userId}`);
        return response;
    }

    async createStopReferralAction(payload) {
        const response = await axios.post('user/stopReferralAction', payload);
        return response;
    }

    async getStopReferralActions(userId) {
        const response = await axios.get(`user/stopReferralAction/${userId}`);
        return response;
    }

    async getUserPracticeAreas(userId, sourceId) {
        const response = await axios.get(
            `user/practiceArea/${userId}/${sourceId}`,
        );
        return response;
    }

    async addOrUpdatePracticeArea(payload) {
        const response = await axios.post('user/practiceArea', payload);
        return response;
    }

    async addPracticeAreaList(userId, payload) {
        const response = await axios.post(
            `user/practiceAreaList/${userId}`,
            payload,
        );
        return response;
    }

    async updateUserPracticeArea(userPracticeAreaId, payload) {
        const response = await axios.put(
            `user/practiceArea/${userPracticeAreaId}`,
            payload,
        );

        return response;
    }

    async updateLrsLawyerStatus(lawyerId, payload) {
        const response = await axios.put(
            `user/lrsLawyerStatus/${lawyerId}`,
            payload,
        );
        return response;
    }

    async getUsersByNameOrMemberId(payload) {
        const response = await axios.get(
            `user/by_name_or_memberid?${serializeQuery(payload)}`,
        );
        return response;
    }

    async resendVerificationEmail(emailAddress) {
        const response = await axios.get(
            `auth/email/resend-verification/${emailAddress}`,
        );
        return response;
    }

    async resendLRSVerificationEmail(emailAddress) {
        const response = await axios.get(
            `auth/email/resend-lrs-verification/${emailAddress}`,
        );
        return response;
    }

    async verifyAccount(verificationCode) {
        const response = await axios.put(
            `auth/email/verify/${verificationCode}`,
        );
        return response;
    }

    async forgotPassword(emailAddress) {
        const response = await axios.get(
            `auth/forgot-password/${emailAddress}`,
        );
        return response;
    }

    async resetPassword(payload) {
        const response = await axios.post('auth/reset-password', payload);
        return response;
    }

    async verifyAndResetPassword(payload) {
        const response = await axios.post(
            'auth/verify_and_reset_password',
            payload,
        );
        return response;
    }

    async googleAuth(payload) {
        const response = await axios.post('auth/google/login', payload);
        return response;
    }

    async exchangeAuth(payload) {
        const response = await axios.post('auth/exchange/login', payload);
        return response;
    }

    async icloudAuth(payload) {
        const response = await axios.post('auth/icloud/login', payload);
        return response;
    }

    async getOutlookAuthUrl() {
        const response = await axios.get('auth/outlook/authUrl');
        return response;
    }

    async outlookAuth(payload) {
        const response = await axios.post('auth/outlook/login', payload);
        return response;
    }

    async saveBusinessHours(payload) {
        const response = await axios.post('user/businessHours', payload);
        return response;
    }

    async getBusinessHours(userId) {
        const response = await axios.get(`user/businessHours/${userId}`);
        return response;
    }

    async getAvailableLawyers(payload) {
        const response = await axios.get(
            `user/availabelLawyers?${serializeQuery(payload)}`,
        );
        return response;
    }

    async getLawyerAvailableHours(payload) {
        const response = await axios.get(
            `user/lawyerAvailableHours?${serializeQuery(payload)}`,
        );
        return response;
    }

    async getUsersByIds(payload) {
        const response = await axios.get(`user/by_ids?ids=${payload}`);
        return response;
    }

    async getUsersByRole(roleId) {
        const response = await axios.get(`user/by_role/${roleId}`);
        return response;
    }

    async createStripeCustomer(userId, payload) {
        const response = await axios.post(
            `user/stripeCustomer/${userId}`,
            payload,
        );

        return response;
    }

    async createStripeConnectAccount(userId, payload) {
        const response = await axios.post(
            `user/stripeAccount/${userId}`,
            payload,
        );
        return response;
    }

    async getStripeConnectAccount(userId) {
        const response = await axios.get(`user/stripeAccount/${userId}`);
        return response;
    }

    async changePassword(userId, payload) {
        const response = await axios.post(
            `auth/change-password/${userId}`,
            payload,
        );

        return response;
    }

    async sendTwoFaCode(payload) {
        const response = await axios.post('auth/send-2fa-code', payload);
        return response;
    }

    async toggleTwoFa(payload) {
        const response = await axios.post('auth/toggle-2fa', payload);
        return response;
    }
}

export default new UserRepository();
